import {
  post
} from '@/common/http.js'
import constant from '@/common/constant'
import appconfig from '@/appconfig.js'

export const CaptchaPath = appconfig.httpServer + constant.apiBase + 'captcha';
export const Jump = params => post('admin_login', params)
export const Login = params => post('login', params, {
  userName: {
    rule: 'required',
    msg: '请输入账号'
  },
  captcha: {
    rule: 'required',
    msg: '请输入验证码'
  },
  password: {
    rule: 'required',
    msg: '请输入密码'
  }
})

export const ShowInfo = params => post('account/show_info', params, {})

export const sendMobile = params => post('verify/mobile_send', params, {
  mobile: {
    rule: /^1\d{10}$/,
    msg: '请输入正确的手机号'
  },
  verifyCode: {
    rule: 'required',
    msg: '请输入图形验证码'
  }
}) // 发送手机验证码

export const codeLogin = params => post('code_login', params, {
  userName: {
    rule: /^1\d{10}$/,
    msg: '请输入正确的手机号'
  },
  verifyCode: {
    rule: 'required',
    msg: '请输入短信验证码'
  }
}) // verificationCodeLogin



// WEBPACK FOOTER //
// ./src/api/common.js